// src/services/api.js
// Cliente HTTP de la API (Express + PostgreSQL). Reemplaza Firebase.
// REACT_APP_API_URL vacío => '/api' (Netlify lo reenvía al backend).
const BASE = (process.env.REACT_APP_API_URL || '/api').replace(/\/+$/, '');

export function getToken() {
  try { return localStorage.getItem('token') || ''; } catch { return ''; }
}

export function clearSession() {
  try {
    localStorage.removeItem('token');
    localStorage.removeItem('role');
    localStorage.removeItem('email');
  } catch {}
  // remember_email se conserva a propósito (preferencia del usuario)
}

export class ApiError extends Error {
  constructor(message, status, body) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.body = body;
  }
}

/**
 * Llama a la API. Devuelve `data` del sobre { ok, data }.
 * Un 401 con sesión activa cierra la sesión y manda al login.
 */
export async function api(method, path, body, { auth = true } = {}) {
  const headers = {};
  if (body !== undefined) headers['Content-Type'] = 'application/json';
  const token = auth ? getToken() : '';
  if (token) headers.Authorization = `Bearer ${token}`;

  const resp = await fetch(`${BASE}${path}`, {
    method,
    headers,
    body: body !== undefined ? JSON.stringify(body) : undefined,
  });

  let json = null;
  try { json = await resp.json(); } catch {}

  if (resp.status === 401 && token) {
    clearSession();
    if (!window.location.pathname.startsWith('/login')) window.location.assign('/login');
  }
  if (!resp.ok) {
    throw new ApiError(json?.message || `HTTP ${resp.status}`, resp.status, json);
  }
  return json && 'data' in json ? json.data : json;
}

export const apiGet = (path) => api('GET', path);
export const apiPost = (path, body) => api('POST', path, body);
export const apiPut = (path, body) => api('PUT', path, body);
export const apiPatch = (path, body) => api('PATCH', path, body);
export const apiDelete = (path) => api('DELETE', path);
